export default [
  {
    title: '井下开采',
    label: 'Underground Mining',
    folding: true,
    child: [
      {
        title: '采煤设备',
        label: 'Coal Mining Equipment',
        folding: true,
        child: [
          {
            title: '滚筒采煤机',
            label: 'Shearer',
          },
          {
            title: '刨煤机',
            label: 'Coal Plough',
          },
          {
            title: '螺旋钻采煤机',
            label: 'Coal Auger',
          },
          {
            title: '采煤机配件',
            label: 'Shearer Parts',
          },
        ],
      },
      {
        title: '工作面支护',
        label: 'Working Face Support',
        folding: true,
        child: [
          {
            title: '工作面液压支架',
            label: 'Coalface Hydraulic Support',
          },
          {
            title: '端头支架',
            label: 'End Support',
          },
          { title: '过渡支架', label: 'Transition Support' },
          { title: '巷道支架', label: 'Laneway Support' },
          { title: '单体液压支柱', label: 'Monoblock Hydraulic Support' },
          { title: '金属顶梁', label: 'Metal Roof' },
          { title: '液压支架配件', label: 'Hydraulic Support Parts' },
        ],
      },
      {
        title: '工作面输送设备',
        label: 'Working Face Conveying Equipment',
        folding: true,
        child: [
          { title: '工作面刮板输送机', label: 'Scraper Conveyor' },
          { title: '转载机', label: 'Stage Loader' },
          { title: '工作面破碎机', label: 'Working Face Crusher' },
          { title: '皮带自移装置', label: 'Belt Self-advancing unloading device' },
          { title: '玛蒂克（转载机头和带式输送机尾自移装置）', label: 'Stage loaders headdrive and Mobile Tail Drive' },
          { title: '刮板输送机配件-链条', label: 'AFC Parts (Chain)' },
          { title: '刮板输送机配件-圆环链', label: 'AFC Parts ( Endless Chain)' },
          { title: '回柱绞车', label: 'Dispatch Winch' },
          { title: '调度绞车', label: 'Dispatch Winch' },
        ],
      },
    ],
  },
  {
    title: '井下掘进',
    folding: true,
    label: 'Underground Tunneling',
    child: [
      {
        title: '机械化掘进设备',
        label: 'Mechanized Tunneling Equipment',
        child: [
          {
            title: '全断面巷道掘进机',
            label: 'Full Face Tunnel Boring Machine',
          },
          {
            title: '盾构机',
            label: 'Tunneling Shield',
          },
          {
            title: '岩石掘进机',
            label: 'Rock Drilling Rig',
          },
          {
            title: '部分断面掘进机',
            label: 'Partial-Face Excavation Machine',
          },
          {
            title: '悬臂式掘进机',
            label: 'Boom-Type Roadheader',
          },
          { title: '掘锚机', label: 'Bolter Miner' },
          { title: '连续式采煤机', label: 'Continuous Mining Shearer' },
          { title: '掘锚护一体机', label: 'Jumbo Loader' },
          { title: '微盾', label: 'Micro Shield' },
          { title: '顶管机', label: 'Pipe Jacking Machine' },
          { title: '竖井掘进机', label: 'Shaft Drilling Machine' },
          { title: '反井掘进机', label: 'Raise-Bore Machine' },
          { title: '硐室掘进机', label: 'Chamber Tunneling Machine' },
          { title: '斜井掘进机', label: 'Inclined Shaft Sinking Machine' },
          { title: '掘进机配件', label: 'Tunneling Machine Spare Parts' },
        ],
      },
      {
        title: '矿山法掘进设备',
        label: 'Mine Tunneling Equipment',
        folding: true,
        child: [
          {
            title: '凿岩台车',
            label: 'Drill Jumbo',
          },
          {
            title: '锚杆台车',
            label: 'Rock bolting rigs',
          },
          { title: '凿岩机', label: 'Rock Drill' },
          { title: '湿喷台车', label: 'Wet Spray Trolley' },
          { title: '喷浆机', label: 'Pulp Sprayer' },
          { title: '撬毛车', label: 'Mechanical Scaler' },
          { title: '钻装一体机', label: 'Drill Machine' },
        ],
      },
      {
        title: '后配套系统',
        label: 'Back Up System',
        folding: true,
        child: [
          { title: '管片拼装机', label: 'Segment Erector' },
          { title: '装载机', label: 'Loader' },
          { title: '侧卸式矿车', label: 'Granby Car' },
          { title: '地下铲运机', label: 'Underground Bowl Scraper' },
          { title: '地下运矿卡车', label: 'Underground Mine Truck' },
        ],
      },
      {
        title: '支护机具',
        label: 'Supporting Machines and Tools',
        folding: true,
        child: [
          { title: '锚杆钻机', label: 'Anchor Drill' },
          { title: '巷道修复机', label: 'Roadway Repair Machine' },
          { title: '张拉机具', label: 'Tensioner' },
          { title: '凿岩钎具-钻杆', label: 'Rock Drilling Tool  (Drill Rod)' },
          { title: '凿岩钎具-钻头', label: 'Rock Drilling Tool  (Drilling Head )' },
          { title: '锚杆', label: 'Anchor Rod' },
          { title: '锚索', label: 'Anchor Cable' },
          { title: '锚固剂', label: 'Anchoring Agent' },
          { title: '锚网连扣机', label: 'Anchor Coupling Machine' },
        ],
      },
    ],
  },
  {
    title: '井下运输',
    label: 'Underground Transportation',
    folding: true,
    child: [
      {
        title: '皮带运输',
        label: 'Belt Conveyor',
        folding: true,
        child: [
          { title: '带式输送机', label: 'Belt Conveyor' },
          { title: '气浮皮带输送机', label: 'Float Dynamics Conveyor' },
          { title: '带式转载机', label: 'Belt Reversed Loader' },
          { title: '滚筒（硫化包胶）', label: 'Drum (Vulcanized)' },
          { title: '自移机尾', label: 'Mobile Tail Piece' },
          { title: '输送带', label: 'Conveyor Belt' },
          { title: '带扣', label: 'Conveyor Connector' },
          { title: '输送带修复技术', label: 'Conveyor Repair Technology' },
          { title: '托辊', label: 'Idler' },
          { title: '清扫器', label: 'Cleaning Device' },
          { title: '逆止器', label: 'Inverter' },
          { title: '纠偏器', label: 'Corrector' },
          { title: '制动器', label: 'Brake' },
        ],
      },
      {
        title: '辅助运输——轨道运输',
        label: 'Auxiliary Transportation - Rail Transportation',
        folding: true,
        child: [
          { title: '蓄电池电机车', label: 'Battery Locomotive' },
          { title: '架线式电机车', label: 'Overhead Line Electric Locomotive' },
          { title: '采油机牵引车', label: 'Oil Extraction Tractor' },
          { title: '井下人车', label: 'Underground Miner Car' },
          { title: '平板车', label: 'Flatbed Truck ' },
          { title: '矿车', label: 'Minecart' },
          { title: '梭车', label: 'Shuttle Car' },
          { title: '仓式列车', label: 'Bunker Train' },
          { title: '翻车机', label: 'Car Dumper' },
          { title: '推车机', label: 'Car Pusher' },
          { title: '爬车机', label: 'Creeper' },
          { title: '阻车器', label: 'Car Stop' },
          { title: '单轨吊车', label: 'Monorail Hoist' },
          { title: '单轨吊机车', label: 'Monorail Crane' },
          { title: '架空乘人装置', label: 'Overhead Manriding Carriage' },
          { title: '齿轨机车', label: 'Rack Rail Locomotive' },
          { title: '卡轨车', label: 'Floor-mounted Rail Locomotive' },
        ],
      },
      {
        title: '辅助运输——无轨运输',
        label: 'Auxiliary Transportation - Trackless Transportation',
        folding: true,
        child: [
          { title: '绞车', label: 'Winch' },
          { title: '无轨胶轮车', label: 'Trackless Tyred Vehicle' },
          { title: '胶套轮机车', label: 'Rubber-Tyred Locomotive' },
          { title: '起重设备', label: 'Hoisting Equipment' },
        ],
      },
      {
        title: '矿井提升',
        label: 'Mine Hoisting',
        folding: true,
        child: [
          { title: '提升机', label: 'Hoist' },
          { title: '箕斗', label: 'Skip' },
          { title: '罐笼', label: 'Cage' },
          { title: '吊桶', label: 'Bucket' },
          { title: '罐道', label: 'Cage Guide' },
          { title: '制动器', label: 'Brake' },
          { title: '防坠器', label: 'Safety Catcher' },
          { title: '斜井提升设备', label: 'Inclined Shaft Hoisting' },
        ],
      },
    ],
  },
  {
    title: '煤矿机电与动力',
    label: 'Coal Mine Electromechanical and Power',
    folding: true,
    child: [
      {
        title: '矿井供配电',
        label: 'Coal Mine Power Supply',
        folding: true,
        child: [
          { title: '移动变电站', label: 'Mobile Substation' },
          { title: '变压器', label: 'Transformer' },
          { title: '组合', label: 'Combination Switch' },
          { title: '馈电开关', label: 'Feeder Switch' },
          { title: '高压', label: 'High Pressure' },
          { title: '低压变频器', label: 'Low Pressure Frequency Inverter' },
          { title: '电磁启动器', label: 'Electromagnetic Starter' },
          { title: '漏电保护装置', label: 'Leak-Protective Device' },
          { title: '保护器', label: 'Protector' },
          { title: '低压侧保护箱', label: ' Low Pressure Guard Box' },
          { title: '电抗器', label: 'Electric Reactor' },
          { title: '电容', label: 'Capacitor' },
          { title: '电控箱', label: 'Electric Control Panel' },
          { title: '矿用电缆', label: 'Coal Mine Cable ' },
          { title: '电缆连接器', label: 'Cable Connector' },
        ],
      },
      {
        title: '电机',
        label: 'Electric Machine',
        folding: true,
        child: [
          { title: '防爆电动机', label: 'Explosion Proof Electric Motor' },
          { title: '电机', label: 'Engine' },
          { title: '永磁电机', label: 'Permanent-magnet  Motor' },
          { title: '发电设备', label: 'Power Generating Equipment' },
          { title: '柴油机', label: 'Diesel Engine' },
          { title: '发动机', label: 'Engine Starter' },
        ],
      },
      {
        title: '泵',
        label: 'Pump',
        folding: true,
        child: [
          { title: '乳化液泵站', label: 'Emulsion Pump Station' },
          { title: '喷雾泵站', label: 'Spray Pump Station' },
          { title: '液压泵', label: 'Hydraulic Pump' },
          { title: '柱塞泵', label: 'Plunger Pump' },
          { title: '注浆', label: 'Grouting' },
          { title: '压裂泵', label: 'Fracturing Pump' },
          { title: '冷却用水泵', label: 'Cooling Pump' },
        ],
      },
      {
        title: '液压传动',
        label: 'Hydraulic Transmission',
        folding: true,
        child: [
          { title: '液压马达', label: 'Hydraulic Motor' },
          { title: '油箱', label: 'Oil Tank' },
          { title: '油缸', label: ' Oil Cylinder' },
          { title: '液压缸', label: 'Hydraulic Cylinder' },
          { title: '液压控制阀', label: 'Hydraulic Control Valve' },
          { title: '轴承', label: 'Bearings' },
          { title: '联轴器', label: 'Coupling' },
          { title: '蓄能器', label: 'Accumulator' },
          { title: '齿轮箱', label: 'Gearbox' },
          { title: '减速机', label: 'Gear Reducer' },
          { title: '减速器', label: 'Reduction Drive' },
          { title: '逆止器', label: 'Backstop' },
          { title: '限矩器', label: 'Torque Limiter' },
          { title: '油管', label: 'Oil Tube ' },
          { title: '软管', label: 'Hose' },
          { title: '管接头', label: 'Pipe Joint' },
          { title: '保护套', label: 'Pipe Sleeve' },
          { title: '冷却器', label: 'Cooler ' },
          { title: '加热器', label: 'Heatbooster' },
          { title: '过滤器', label: 'Filter Apparatus' },
          { title: '滤芯', label: 'Filter Cartridge' },
          { title: '液位计', label: 'Fluid Gauge' },
          { title: '密封件', label: 'Seals' },
        ],
      },
      {
        title: '压气设备',
        label: 'Compressor Equipment',
        folding: true,
        child: [
          { title: '矿山空气压缩机', label: 'Mine Air Compressor' },
          { title: '气动马达', label: 'Pneumatic Motors.' },
          { title: '空气过滤器', label: 'AirFilter' },
          { title: '油水分离器', label: 'Deoiler' },
          { title: '风包', label: 'Pressurized Gas Storage Tanks ' },
          { title: '储气罐', label: 'Gas Tank' },
          { title: '空气管网', label: 'Air Pipe Network' },
        ],
      },
      {
        title: '钻机',
        label: 'Rigs',
        folding: true,
        child: [
          { title: '定向钻机', label: 'Directional Drilling Rig' },
          { title: '切顶钻机', label: 'Top Cutting Rig' },
          { title: '坑道钻机', label: 'Tunnel Drilling Rig' },
          { title: '深孔钻车', label: 'Deephole Drilling Carriage' },
          { title: '反井钻机', label: 'Raise Boring Rig' },
        ],
      },
    ],
  },
  {
    title: '煤矿辅助生产系统',
    label: 'Coal Mine Auxiliary Production System',
    folding: true,
    child: [
      {
        title: '排水设备',
        label: 'Drainage Equipment',
        folding: true,
        child: [
          { title: '潜水泵', label: 'Submersible Pump' },
          { title: '渣浆泵', label: 'Slurry Pump' },
          { title: '离心泵', label: 'Centrifugal Pump' },
          { title: '矿井水处理设备', label: 'Mine Water Treatment Equipment' },
        ],
      },
      {
        title: '通风设备',
        label: 'Ventilation Equipment',
        folding: true,
        child: [
          { title: '离心式', label: 'Centrifugal Ventilator' },
          { title: '轴流式通风机', label: '轴流式通风机' },
          { title: '局部通风机', label: 'Partial Ventilator' },
          { title: '抑尘系统', label: 'Dust Control System' },
          { title: '除尘风机', label: 'Dedusting Fan' },
          { title: '反风装置', label: 'Airflow Reversing Equipment' },
          { title: '扩散器', label: 'Diffuser' },
          { title: '风筒', label: 'Fan Drum' },
          { title: '智能无压风门', label: 'Smart Pressure-Free Damper' },
        ],
      },
      {
        title: '通信、照明设备',
        label: 'Communication and Lighting Equipment',
        folding: true,
        child: [
          { title: '矿用无线通信系统', label: 'Mine Wireless Communication' },
          { title: '煤矿调度广播通讯系统', label: 'Coal Mine Dispatching Broadcasting Communication system' },
          { title: '矿用视频监控系统', label: 'Coal Mine Video Surveillance System' },
          { title: '矿灯', label: "Coal Miner's Lamp" },
          { title: '充电架', label: 'Charging Frame' },
          { title: '矿用电话', label: 'Coal Mine Phone' },
          { title: '防爆矿灯灯具', label: 'Explosion Proof Lamp' },
        ],
      },
      {
        title: '安全生产及救援',
        label: 'Safety Production and Rescue',
        folding: true,
        child: [
          { title: '安全生产监控系统', label: 'Safety  Production Monitoring System' },
          { title: '井下防火灭火系统', label: 'Underground Fire Prevention and Extinguishing System' },
          { title: '制氮设备及管路', label: 'Nitrogen Generating Equipment and Piping System' },
          { title: '瓦斯检测抽放系统', label: 'Gas Detection And Drainage System' },
          { title: '探水装备', label: 'Water Exploration Equipment' },
          { title: '井下救生舱', label: 'Underground Life Saving Cabin' },
          { title: '矿井自救抢险装置', label: 'Coal Mine Self-Help Rescue Equipment' },
        ],
      },
      {
        title: '环境保护设备',
        label: 'Environmental Protection System',
        folding: true,
        child: [
          { title: '矿山环境保护与复垦', label: 'Mine Environmental Protection and Reclamation' },
          { title: '矸石充填设备', label: 'Gangue Filling Equipment' },
          { title: '三下开采设备', label: 'Mining Equipment for Surface Under Water Bodies, Building & Railway' },
          { title: '废水处理解决方案', label: 'Waste Water Treatment Solution' },
          { title: '生产生活污水处理设备', label: 'Sewage Treatment Plant' },
        ],
      },
    ],
  },
  {
    title: '自动化控制和煤矿智能化',
    label: 'SMART Mine & Automation',
    folding: true,
    child: [
      {
        title: '煤矿自动化控制',
        label: 'Coal Mine Automation',
        folding: true,
        child: [
          { title: '综采自动化智能化系统', label: 'Automation and Intelligent System of Fully Mechanized Mining Equipment' },
          { title: '掘进自动化控制系统', label: 'Roadheader Automatic Control System' },
          { title: '智能化矿井运输无人系统', label: 'Unmanned Transportation System in Smart Mine' },
          { title: '矿井提升自动化系统', label: 'Mine Hoisting Automatic System' },
          { title: '智能通风系统', label: 'Intelligent Ventilation System' },
          { title: '智能配电监控系统', label: 'Intelligent Power Distribution Monitoring System' },
          { title: '泵站健康系统', label: 'Pump Station Performance Evaluation System' },
          { title: '洗选设备监控', label: 'Coal Preparation Equipment Monitoring' },
          { title: '矿山压力监测系统', label: 'Underground Pressure Observation System' },
          { title: '无人值守综合管理系统', label: 'Unmanned Integrated Management System' },
          { title: '智能运维管理系统', label: 'Intelligent Operation Management System' },
          { title: '井下人员管理系统', label: 'Management System for Underground Coal Mine Personnel' },
        ],
      },
      {
        title: '煤矿智能化配套技术',
        label: 'Supporting Technology for Coal Mine Automation',
        folding: true,
        child: [
          { title: '防爆计算机', label: 'Explosion-Proof Computer' },
          { title: '交换机', label: 'Switch' },
          { title: '工业服务器', label: 'Industrial Server' },
          { title: '光纤和射频', label: 'Fiber Optic and Radio Frequency' },
          { title: '遥控器', label: 'Remote Control' },
          { title: '传感器', label: 'Sensor' },
          { title: '雷达', label: 'Rader' },
          { title: '物联网解决方案', label: 'Solutions for IOT' },
          { title: '虹膜机', label: 'Iris Analyzer' },
          { title: '煤矿机器人', label: 'Coal Mine Robot' },
        ],
      },
    ],
  },
  {
    title: '煤炭加工利用',
    label: 'Coal Processing & Utilization',
    folding: true,
    child: [
      {
        title: '洗选设备',
        label: 'Coal Washing Equipment',
        folding: true,
        child: [
          { title: '筛分设备', label: 'Sieving Equipment' },
          { title: '智能干选设备', label: 'Intelligent Dry Separating Equipment' },
          { title: '智能煤矸分选机器人', label: 'Intelligent Gangue Separation' },
          { title: '筛板', label: 'Sieve Plate' },
          { title: '压滤机', label: 'Filter-Press' },
          { title: '跳汰机', label: 'Jigging Machine ' },
          { title: '浮选机', label: 'Flotation machine' },
          { title: '重介质旋流器', label: 'Dense Medium Cyclone' },
        ],
      },
      {
        title: '煤炭加工利用',
        label: 'Coal Processing and Utilization',
        folding: true,
        child: [
          { title: '煤化工', label: 'Coal Chemical Industry' },
          { title: '煤制油', label: 'Coal Derived Oil' },
          { title: '洁净煤技术', label: 'Clean Coal Technology' },
        ],
      },
    ],
  },
  {
    title: '露天采矿',
    label: 'Open-Air Mining',
    folding: true,
    child: [
      {
        title: '露天开采设备',
        label: 'Open-Air Mining Equipment',
        folding: true,
        child: [
          { title: '露天采煤机', label: 'Opencast Shearer' },
          { title: '电铲', label: 'Power Shovel' },
          { title: '液压挖掘机', label: 'Hydraulic Excavator' },
          { title: '轮斗挖掘机', label: 'Bucket Wheel Excavator' },
          { title: '钻车', label: 'Drilling Car' },
          { title: '钻机', label: 'Drilling Rig' },
        ],
      },
      {
        title: '运输设备',
        label: 'Transportation Equipment',
        folding: true,
        child: [
          { title: '装载机', label: 'Loader' },
          { title: '矿用卡车', label: 'Mine Truck' },
          { title: '电动宽体车', label: 'Electric Wide Body Car' },
          { title: '铲运机', label: 'Scraper' },
          { title: '矿用自卸汽车', label: 'Mining Dump Truck' },
        ],
      },
      {
        title: '辅助设备',
        label: 'Auxiliary Equipment',
        folding: true,
        child: [
          { title: '旋回', label: 'Cycle' },
          { title: '颚式破碎机', label: 'Jaw Crusher' },
          { title: '发电机组', label: 'Generator Set' },
        ],
      },
    ],
  },
  {
    title: '矿山服务与工程',
    label: 'Coal Mine Services and Engineering',
    folding: true,
    child: [
      {
        title: '服务贸易',
        label: 'Trading Service',
        folding: true,
        child: [
          { title: '设计', label: 'Design' },
          { title: '咨询服务', label: 'Consultant Service' },
          { title: '代理贸易', label: 'Agency Trade' },
          { title: '新闻媒体', label: 'News Media' },
          { title: '政府单位', label: 'Government' },
          { title: '协会组织', label: 'Association ' },
          { title: '教育培训', label: 'Education Training' },
          { title: '劳务服务', label: 'Labor Service' },
          { title: '金融', label: 'Finance' },
          { title: '租赁', label: 'Leasing ' },
          { title: '保险', label: 'Insurance' },
          { title: '二手设备', label: '2nd Hand Equipment' },
          { title: '劳动保护及职业健康', label: 'Labor Protection And Occupational Health' },
          { title: '软件', label: 'Software' },
          { title: '煤机电商', label: ' Mechanical & Electrical Equipment Manufacturer' },
        ],
      },
      {
        title: '勘探、建井与工程',
        label: 'Exploration and Mine Construction',
        folding: true,
        child: [
          { title: '地质勘探', label: 'Land Exploration ' },
          { title: '矿山测量', label: 'Mine Survey' },
          { title: '矿井建设', label: 'Mine Construction' },
          { title: '工程承包', label: 'Project Contracting' },
          { title: '托管运营', label: 'Trusteeship' },
          { title: '交钥匙工程', label: 'Turn-Key Engineering' },
          { title: '煤层气开发与利用', label: 'Development and Utilization of Coalbed Methane' },
          { title: '矿井降温', label: 'Coal Mine Cooling' },
          { title: '选煤厂托管运营', label: 'Coal Preparation Plant Management and Operation' },
        ],
      },
    ],
  },
  {
    title: '矿用物资、工具及加工制造',
    label: 'Mine Material/ Instruments and Processing',
    folding: true,
    child: [
      {
        title: '矿用物资材料',
        label: 'Mine Resources & Materials',
        folding: true,
        child: [
          { title: '矿用油品（润滑油）', label: 'Mine Oil (Lubricant)' },
          { title: '乳化油', label: 'Emulsifying Oil' },
          { title: '浓缩液', label: 'Concentrated Liquid' },
          { title: '防冻液', label: 'Antifreeze Liquid' },
          { title: '非金属安全材料', label: 'Non-metallic Safety Material' },
          { title: '安全爆破器材', label: 'Safe Explosive Materials' },
          { title: '化学产品', label: 'Chemical Product' },
          { title: '耐磨材料', label: 'Wear-Resistant Materials' },
          { title: '钢板', label: 'Steel Plate' },
          { title: '钢轨', label: 'Steel Rail' },
          { title: '钢丝绳及检测服务', label: 'Wire Rope and Testing Service' },
          { title: '硬质合金', label: 'Carbide Alloy' },
          { title: '刀具', label: 'Cutter' },
          { title: '锂电池电源', label: 'Lithium Battery Power' },
          { title: '矿山专用轮胎', label: 'Industrial Mining Tire' },
          { title: '轮辋', label: 'Wheel' },
        ],
      },
      {
        title: '矿用工具、仪器、仪表',
        label: 'Mine Equipment/ Apparatus/ Instrumentation',
        folding: true,
        child: [
          { title: '手动', label: 'Manual' },
          { title: '电工', label: 'Electrical ' },
          { title: '动力工具', label: 'Power Tool' },
          { title: '物探', label: 'Geophysical' },
          { title: '测量仪器', label: 'Measuring Instrument' },
          { title: '温度', label: 'Temperature' },
          { title: '气体', label: 'Gas' },
          { title: '压力检测仪器', label: 'Pressure Detection Equipment ' },
          { title: '煤质分析仪器', label: 'Coal Quality Analysis' },
          { title: '自动化仪表', label: 'Automation Instrumentation' },
        ],
      },
      {
        title: '加工制造',
        label: 'Processing & Utilization',
        folding: true,
        child: [
          { title: '激光熔覆', label: 'Laser Cladding' },
          { title: '再制造', label: 'Remanufacturing ' },
          { title: '设备修造', label: 'Equipment Restoration' },
          { title: '焊接技术', label: 'Welding Technique' },
          { title: '焊接材料', label: 'Welding Material' },
          { title: '锻件加工', label: 'Forging Process' },
          { title: '珩磨加工', label: 'Honing Process' },
          { title: '内喷雾', label: 'Internal Spraying' },
        ],
      },
    ],
  },
];
